module.exports = __webpack_public_path__ + "static/media/Drawing-kamasutragame.cb14f79a.jpg";